/** @type {import("../types/mutations/user").UserMutationKeys} */
const user_mutation_keys = {
    "SET": "USER/SET",
    "SET_LOCALE": "USER/SET_LOCALE"
};

/**
 * Representing user mutations.
 * @type {import("../types/mutations/user").UserMutations}
 */
const user_mutations = {
    /** Setting authenticated user. */
    [user_mutation_keys.SET]: (state, user) => state.user = user,
    
    /** Set authenticated user locale. */
    [user_mutation_keys.SET_LOCALE]: (state, locale) => state.locale = locale,
}

export default user_mutations;

export { user_mutation_keys }